// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"07ec4697","36":"dac12c84","129":"7b339aa6","529":"d53d08ff","787":"f9a2c659","919":"3b75d085"}[chunkId] + ".chunk.js";
};